'use strict';

function MoneyUpDashboardHome() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_AccountController];
  this.history = new History();
  this._dashboardPageInitialized = false;
  this._loadedSections = [];

  this.chatOptions = null;

  this.products = ['CreditScore', 'Loans', 'Wealth'];

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
    this.$node = $(this.node);

    if (this.validated) {
      this._portalPresenter = document.getElementById('Portal').mogo();
      this._productSettings = this._portalPresenter._productSettings;

      this.analytics.forcePushEvent('virtual-page-view');
      this.analytics.forcePushEvent('nc-status', {
        notification: [this.presenter.getModelProperty('account.unseen_message_count')]
      });
      this._pushReferralCellAnalytics();

      // set up legal disclaimer component in case it's needed
      this._legalDisclaimer();
      this._setupLivechat();

      this._loadPageSections();

      // setTimeout(() => {
      //   this.node.getElementsByClassName('js--content-center')[0].mogo().create('ContentCenter', {
      //     presenter: this.presenter
      //   });
      // }, 2000);
    }
  };

  this.hasViewedRelatedContent = function () {
    // user must view interstitial content or related content only once
    var relatedContentIds = ['main-dashboard-interstitial', 'main-dashboard-crypto-tiers-referral-interstitial'];

    var hasViewedRelatedContent = false;
    for (var idIndex = 0; idIndex < relatedContentIds.length; idIndex++) {
      if (this._productSettings.hasViewedContent('' + relatedContentIds[idIndex])) {
        hasViewedRelatedContent = true;
      }
    }

    return hasViewedRelatedContent;
  };

  this._setupLivechat = function () {
    var _this = this;

    // LiveChat component exists outside of the Portal if it has already been created
    // Onload: Hide chat bubble on dashboard if visitors are not engaged
    this._liveChat = this.$node.find('.js--live-chat');
    this._liveChatComponent = $("[data-mogo-UI='LiveChat']");

    // The first 'if' condition references when the chat is not yet initialized.
    // EX: coming from another page (Portal, help etc)
    // In this case, create a Livechat component and then check
    // if visitors are engaged, open chat, else hide it.
    if (this._liveChat.length && !this._liveChatComponent.length) {
      this._liveChat.mogo().create('LiveChat', {
        presenter: this.presenter,
        afterLoad: function afterLoad() {
          this._liveChat.mogo().minimizeChatWindow();
        }
      });
    } else if (this._liveChatComponent.length && this._liveChatComponent.mogo().declaredClass) {
      var liveChatReady = this._liveChatComponent.mogo().afterLoadPromise;
      $.when(liveChatReady).then(function () {
        _this._liveChatComponent.mogo().minimizeChatWindow();
        _this._liveChat = _this._liveChatComponent;
      });
    }
  };

  this.initDashboardIfReady = function () {
    var _this2 = this;

    if (!this._dashboardPageInitialized && this.products.every(function (product) {
      return _this2._loadedSections.includes('MoneyUpDashboardHome' + product);
    })) {
      this._dashboardPageInitialized = true;
      this.initPage();
    }
  };

  this.initPage = function () {};

  this._loadPageSections = function () {
    var _this3 = this;

    this.products.forEach(function (product) {
      $('.js--dashboard-product-' + product.toLowerCase(), _this3.node).mogo().create('MoneyUpDashboardHome' + product, {
        presenter: _this3.presenter,
        analytics: _this3.analytics,
        product: product.toLowerCase(),
        onComplete: $.proxy(function () {
          this._loadedSections.push('MoneyUpDashboardHome' + product);
          this.initDashboardIfReady();
        }, _this3)
      }, 'page');
    });
  };

  // Analytics for this cell is not inside MoneyUpProductCell.js
  // like other cells because this one is contentful driven
  // and not bound to service / connection issues dont apply
  this._pushReferralCellAnalytics = function () {
    this.analytics.forcePushEvent('hd-cell-status', {
      cell: ['Referral'],
      notification: ['Normal']
    });
  };

  this._legalDisclaimer = function () {
    var legal = $('.js--legal-disclaimer', this.node);

    if (legal.length && legal.mogo && legal.mogo().create) {
      legal.mogo().create('LegalDisclaimer', {
        legal: $('[data-legal]:visible', this.node),
        presenter: this.presenter
      });
    }
  };

  this.destroy = function () {
    var isDashboardHome = window.location.pathname.includes('/member/dashboard/home');
    // Note: components get destroyed on view switch on some places (tray),
    // which is why sometimes mogo() of undefined error comes up.
    if (!isDashboardHome && this._liveChat) {
      if (this._liveChat.mogo() && this._liveChat.mogo().declaredClass && this._liveChat.mogo().clear) {
        this._liveChat.mogo().clear();
      }
    }
  };
}